import { find } from "lodash";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";

import { Button, Grid, Container, Card, Typography, Box } from "@mui/material";
import List from "../../components/shared/List";
import Dialog from "../../components/shared/Dialog";

import { useDispatch } from "react-redux";
import LabelTextField from "../../components/shared/LabelTextField";
import Dropdown from "../../components/shared/DropDown";
import Iconify from "../../components/iconify/iconify";
import { color } from "../../utils/constant";
import { resetState } from "../../data/reducers/Leave/leaveForm.reducer";
import {
  getLeaveList,
  getPaginationInfo,
} from "../../data/selectors/Leave/leave.selector";
import useLeave from "../../data/talons/Leave/useLeave";
import { useLeaveForm } from "../../data/talons/Leave/useLeaveForm";
import LeaveForm from "./LeaveForm";
/**
 * Render Category screen with list of data
 * data will taken from the selector
 *
 */
export default function Leave() {
  const [showDialog, setShowDialog] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [editId, setEditId] = useState(null);
  const [Open, setOpen] = useState(false);
  const LeaveList = useSelector(getLeaveList);
  const paginationInfo = useSelector(getPaginationInfo);

  const dispatch = useDispatch();
  const {
    gridHeaders,
    loading,
    loader,
    status,
    StatusList,
    leaveType,
    handleLeaveTypeChange,
    handleStatusChange,
    fetchLeaveList,
  } = useLeave();

  const { getLeaveById, leaveDelete, handleDeleteId } = useLeaveForm({});

  useEffect(() => {
    fetchLeaveList({
      current_page: 1,
      row_count: rowsPerPage,
    });
  }, [rowsPerPage]);

  const onSubmit = useCallback(
    async (e) => {
      e?.preventDefault();
      await fetchLeaveList({
        current_page: 1,
        row_count: rowsPerPage,
      });
    },
    [fetchLeaveList]
  );

  return (
    <Container
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        mt: 1,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={2}>
          <Dropdown
            size={"small"}
            title={"Status"}
            data={StatusList}
            handleDropdownChange={handleStatusChange}
            dropdownValue={status}
            allReqired={true}
            allStatusVal="0"
          />
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-right"
          item
          xs={6}
          sm={3}
          md={2}
        >
          <Button
            variant="contained"
            onClick={onSubmit}
            sx={{
              maxHeight: 40,
              backgroundColor: color.button,
              borderRadius: 3,
              "&:hover": {
                backgroundColor: color.button,
              },
            }}
          >
            Get Data
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          sm={3}
          md={2}
          sx={{ marginLeft: "auto", textAlign: "end" }}
        >
          <Button
            sx={{
              height: 40,
              borderRadius: 3,
              backgroundColor: color.button,
              "&:hover": {
                backgroundColor: color.button,
              },
            }}
            onClick={() => setShowDialog(true)}
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
          >
            {"New"}
          </Button>
          <Dialog
            handleClose={() => {
              setShowDialog(false);
              setEditId(null);
              dispatch(resetState());
              fetchLeaveList({ current_page: 1, row_count: rowsPerPage });
            }}
            open={showDialog}
            fullWidth={true}
          >
            <LeaveForm
              postSubmit={async () => {
                setShowDialog(false);
                setEditId(null);
                await fetchLeaveList({
                  current_page: 1,
                  row_count: rowsPerPage,
                });
                dispatch(resetState());
              }}
              editId={editId}
            />
          </Dialog>
          <Dialog
            handleClose={() => {
              setOpen(false);
            }}
            open={Open}
            // fullWidth={true}
          >
            <Typography sx={{ fontWeight: "bold" }}>
              Confirm to Delete this Data ?.
            </Typography>
            <Box sx={{ display: "flex", gap: 1, mt: 2, justifyContent: "end" }}>
              <Button
                onClick={async () => {
                  const res = await leaveDelete();
                  if (res == true) {
                    setOpen(false);
                    await getLeaveById(editId);
                    fetchLeaveList({ current_page: 1, row_count: rowsPerPage });
                  }
                }}
                sx={{ background: color.button }}
                variant="contained"
              >
                Yes
              </Button>
              <Button
                onClick={() => setOpen(false)}
                sx={{ background: color.button }}
                variant="contained"
              >
                No
              </Button>
            </Box>
          </Dialog>
        </Grid>
      </Grid>
      <Card
        sx={{
          flexGrow: { md: 1 },
          display: { md: "flex" },
          flexDirection: { md: "column" },
          my: "12px",
          borderRadius: "12px",
          boxShadow:
            "0 0 2px 0 rgba(145, 158, 171, 0.2),0 12px 24px -4px rgba(145, 158, 171, 0.12)",
        }}
      >
        <List
          loading={loading}
          data={LeaveList}
          paginationData={paginationInfo}
          columnsData={gridHeaders}
          getRowId={(row) => row.id}
          autoHeight={true}
          pageCount={Number(paginationInfo.total_page)}
          totalRecords={paginationInfo.total_count}
          onPageChange={async (page, rowsPerPage) => {
            setRowsPerPage(rowsPerPage);
            await fetchLeaveList({
              current_page: page,
              row_count: rowsPerPage,
            });
          }}
          enableDelete
          onDeleteIconpress={async (row) => {
            handleDeleteId(row);
            setOpen(true);
          }}
          enableEdit
          onEditIconPress={async (id) => {
            await getLeaveById(id);
            setEditId(id);
            setShowDialog(true);
          }}
        />
      </Card>
    </Container>
  );
}
